/**
 * Number formatting utilities for HR Portal
 * Ensures consistent display of leave balances and other numerical values
 */

// Smart formatting: 25.00 → "25", 2.50 → "2.5", 0.50 → "0.5"
export const formatLeaveDays = (days) => {
  if (days === null || days === undefined) return '0';
  const num = parseFloat(days);
  if (isNaN(num)) return '0';
  return num % 1 === 0 ? num.toFixed(0) : parseFloat(num.toFixed(2)).toString();
};

// Conservative rounding for Employee views (round down to nearest 0.5, strip trailing .0)
export const formatLeaveDaysEmployee = (days) => {
  if (days === null || days === undefined) return '0';
  const num = parseFloat(days);
  if (isNaN(num)) return '0';
  const rounded = Math.floor(num * 2) / 2;
  return rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toString();
};

// Currency formatting (standard rounding)
// Pass { grouped: true } for thousands separators, e.g. $1,234.56 (payslips)
export const formatCurrency = (amount, { grouped = false } = {}) => {
  if (amount === null || amount === undefined) return '$0.00';
  const num = parseFloat(amount);
  if (isNaN(num)) return '$0.00';
  if (grouped) {
    return `$${num.toLocaleString('en-SG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return `$${num.toFixed(2)}`;
};

// Percentage formatting
export const formatPercentage = (value, decimals = 1) => {
  if (value === null || value === undefined) return '0%';
  return `${(parseFloat(value) * 100).toFixed(decimals)}%`;
};

// Time formatting (round to nearest minute)
export const formatHoursMinutes = (totalHours) => {
  if (!totalHours) return '0h 0m';

  const hours = Math.floor(totalHours);
  const minutes = Math.round((totalHours - hours) * 60);

  if (minutes === 60) {
    return `${hours + 1}h 0m`;
  }

  return `${hours}h ${minutes}m`;
};

/**
 * Returns "day" or "days" based on the value.
 * 0.5-increment system: only 0.5 and 1 are singular.
 * Zero and values > 1 are plural (English treats zero as plural: "0 days").
 */
export const pluralizeDays = (n) => {
  const abs = Math.abs(parseFloat(n) || 0);
  return (abs === 0.5 || abs === 1) ? 'day' : 'days';
};

// File size formatting
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
